'use client';
import { useEffect } from 'react';
import { debounce } from '../utils/debounce.mjs';

// src/hooks/use-resize-observer.ts
var useResizeObserver = (target, callback) => {
  useEffect(() => {
    callback();
  }, []);
  useEffect(() => {
    if (!target) {
      return;
    }
    let resizeObserverEntries = [];
    let rAF;
    const rAFHandleResize = () => {
      cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(() => {
        callback();
      });
    };
    const debounceHandleResize = debounce(callback);
    const containerWindow = target.ownerDocument.defaultView || window;
    containerWindow.addEventListener("resize", debounceHandleResize);
    let resizeObserver;
    if (typeof ResizeObserver !== "undefined") {
      resizeObserver = new ResizeObserver((entries) => {
        resizeObserverEntries = entries;
        const func = process.env.NODE_ENV === "test" ? rAFHandleResize : callback;
        func();
      });
      resizeObserver.observe(target);
    }
    return () => {
      debounceHandleResize.clear();
      cancelAnimationFrame(rAF);
      containerWindow.removeEventListener("resize", debounceHandleResize);
      resizeObserverEntries.forEach((entry) => entry.target.remove());
      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [target, callback]);
};
var use_resize_observer_default = useResizeObserver;

export { use_resize_observer_default as default };
